import { Area } from '../../../../../../../shared/helpers/layout-manager/types';

/** Рисует готовый слот-битмап в drawArea (с зеркалом для self-видео). */
export function drawPreScaledSlot(
    ctx: CanvasRenderingContext2D,
    bitmap: ImageBitmap,
    area: Area,
    isMirror: boolean
): void {
    if (isMirror) {
        ctx.save();
        ctx.scale(-1, 1);
        ctx.drawImage(bitmap, -area.x, area.y, -area.width, area.height);
        ctx.restore();
        return;
    }
    ctx.drawImage(bitmap, area.x, area.y, area.width, area.height);
}
